var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zg-messaging-inline-text', {
    [`zg-messaging-inline-text--background-${_vm.background}`]: _vm.background,
    [`zg-messaging-inline-text--padding-${_vm.padding}`]: _vm.padding
  }]},[_c('zg-icon',{attrs:{"icon":_vm.icon,"size":"small"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }